<template>
<div class="text-base flex-auto">
        <label for="multiselectReason" class="uppercase disabled:opacity-25 block pb-3 font-medium" v-if="isReturn">{{translations.select_reason}}</label>
        <label for="multiselectReason" class="uppercase disabled:opacity-25 block pb-3 font-medium" v-else>{{ translations.copy }} {{ quantityLabel }}: {{translations.select_reason}}</label>
        <VueMultiselect
            v-model="reasons"
            :options="getReasons()"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :placeholder="translations.select_reason"
            label="name"
            track-by="id"
            id="multiselectReason"
            :preselect-first="false"
            :searchable="false"
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
            openDirection="above"
        >
            <template
                v-slot:selection="{ values, isOpen }">
                <span
                class="multiselect__single multiselect__placeholder__custom"
                v-if="values.length && !isOpen"
                >
                    {{ values.length }} {{translations.x_reasons_selected}}
                </span>
                <span class="multiselect__placeholder__custom" v-else-if="isOpen">{{translations.select_reason}}</span>
            </template>
        </VueMultiselect>
        <div v-if="reasons" v-for="(reason, index) in reasons">
            <Input class="pt-3" v-if="reason.optional_text" v-model="reason.text" :idAttr="'reason' + index" :label="reason.name" :placeholder="translations.please_specifiy" />
            <div v-if="reason.photo_upload">
                <p class="my-3 font-medium">{{reason.name}}</p>
                <p class="mb-3">{{ translations.image_upload_desc }}</p>
                <div class="w-full md:w-2/3" v-if="!isReturn">
                    <div class="my-3 flex gap-3">
                        <div v-if="reason.images" v-for="(image, index) in reason.images" :key="index" class="relative shadow">
                            <span
                                class=" text-red-500 text-2xl absolute top-0 right-0 font-bold"
                                @click="removeImage(index, reason)"
                            >
                            X
                            </span>
                            <Image :imageUrl="createUrl(image)" style="width:65px;"/>
                        </div>
                    </div>
                    <p class="text-red-500 text-sm italic" :class="{'hidden': imageErrorIndex != index}">{{ translations.file_less_than }}</p>
                </div>
                <label class="button button-primary">
                    {{ translations.image_upload_btn }}
                    <input accept="image/x-png, image/jpeg" type="file" ref="uploader" style="display: none" @input="addImage($event.target.files[0], reason, index)" />
                </label>
                <p class="text-sm italic">{{ translations.permitted_file_types }}</p>
                <p class="text-sm italic">{{ translations.file_less_than }}</p>
            </div>
        </div>
</div>
</template>

<script>
import Input from '@/Components/Input'
import Image from '@/Components/Image'
import VueMultiselect from 'vue-multiselect'
export default {
    components: {
        Input,
        Image,
        VueMultiselect
    },
    props: {
        row: Object,
        translations: Object,
        toggleArticle: Boolean,
        isReturn: Boolean,
        quantityLabel: Number,
    },
    data() {
        return {
            reasons: this.row.article.reasons ? [] : null,
            imageErrorIndex: null,
        }
    },
    watch: {
        reasons: {
            deep: true,
            handler() {
                this.$emit('update:modelValue', this.reasons)
            }
        },
        toggleArticle(bool) {
            if(bool) {
                this.reasons = this.row.article.reasons ? [] : null
            }
        }
    },
    methods: {
        addImage(image, reason, index) {
            this.imageErrorIndex = null
            //Sometimes addImage gets called even if file opener gets cancelled.
            if(!image) {
                return
            }
            //Only allow images that are less than 10mb
            if (image.size / (1024 * 1024) > 10) {
                this.imageErrorIndex = index
                return
            }
            if(!reason.images) {
                reason.images = []
            }

            reason.images.push(image)
        },
        createUrl(image) {
            return URL.createObjectURL(image)
        },
        removeImage(index, reason) {
            reason.images.splice(index, 1)
        },
        //Since claim sets reason by quantity we can not reference the same reason array.
        //We instead create a new array for each quantity/multiselect
        getReasons() {
            return JSON.parse(JSON.stringify(this.row.article.reasons))
        }
    },
}

</script>
